import type { FieldMetadataMessageDescriptorDef } from './types';
import { msg } from '@lingui/core/macro';

export const coordinateFields = {
  coordinate_source: {
    displayName: msg({
      message: 'Coordinate source',
      context: 'The display name for the coordinate source field',
    }),
  },
  latitude: {
    displayName: msg({
      message: 'Latitude',
      context: 'The display name for the latitude field',
    }),
  },
  longitude: {
    displayName: msg({
      message: 'Longitude',
      context: 'The display name for the longitude field',
    }),
  },
} as const satisfies Record<string, FieldMetadataMessageDescriptorDef>;
